import { useCallback, useEffect, useState } from "react"

import Company from "models/Company"
import UserService from "services/UserService"
import { Guid } from "@/types"

export default function useCompanies() {
    const [companies, setCompanies] = useState<Company[] | null>(null)

    const fetchCompanies = useCallback(async () => {
        const companiesResp = await UserService.getCompanies()
        setCompanies(companiesResp)
    }, [])

    useEffect(() => {
        fetchCompanies()
    }, [fetchCompanies])

    function getCompanyById(companyId: Guid): Company | undefined {
        return companies?.find(c => c.id === companyId)
    }

    return {
        companies,
        getCompanyById,
    }
}
